import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { articleReadingTimeContent$key } from "scmp-app/queries/__generated__/articleReadingTimeContent.graphql";

import { Container, ReadingTimeDesktop, ReadingTimeMobile, StyledIconClock } from "./styles";

type Props = {
  className?: string;
  reference: articleReadingTimeContent$key;
};

export const ArticleReadingTime: FunctionComponent<Props> = ({ className, reference }) => {
  const content = useFragment(
    graphql`
      fragment articleReadingTimeContent on Content {
        readingTime
      }
    `,
    reference,
  );

  return (
    <Container className={className}>
      <StyledIconClock aria-hidden="true" />
      <ReadingTimeDesktop>{content?.readingTime ?? 1}-MIN READ</ReadingTimeDesktop>
      <ReadingTimeMobile>{content?.readingTime ?? 1}-MIN</ReadingTimeMobile>
    </Container>
  );
};

ArticleReadingTime.displayName = "ArticleReadingTime";
